import React from 'react'

import { interpolateLienInDocTemplate } from '../helper'
import { MaxEditor, getEditorValueAstHtml, updateEditor } from '@/components/MaxEditor'

export function DocsTemplatesEdit({
  dispatch,
  recipients,
  recipientDocuments,
  docTemplates,
  liens,
}) {
  return (
    <ul className='grid gap-7'>
      {recipients.map(({ id: recipientId, profile }) => (
        <div key={recipientId}>
          <h1 className='text-xl font-semibold mb-2'>{profile.email}</h1>

          <ul className='grid gap-7'>
            {recipientDocuments[recipientId]?.map((selectedDoc) => {
              const docTemplate = docTemplates.find((doc) => doc.id === selectedDoc.value)
              const updatedDocTemplate = interpolateLienInDocTemplate(docTemplate, liens)

              return (
                <li key={selectedDoc.value}>
                  <div className='text-md font-semibold text-sky-700 mb-2'>{selectedDoc.label}</div>
                  <MaxEditor
                    customInitialConfig={{
                      namespace: selectedDoc.label,
                      editorState(editor) {
                        updateEditor(editor, updatedDocTemplate)
                        dispatch({
                          type: 'setDocMessages',
                          payload: {
                            recipientId: recipientId,
                            docType: selectedDoc.value,
                            message: updatedDocTemplate,
                          },
                        })
                      },
                    }}
                    onChange={(editorState, editor) => {
                      editorState.read(() => {
                        dispatch({
                          type: 'setDocMessages',
                          payload: {
                            recipientId: recipientId,
                            docType: selectedDoc.value,
                            message: getEditorValueAstHtml(editor),
                          },
                        })
                      })
                    }}
                  />
                </li>
              )
            })}
          </ul>
        </div>
      ))}
    </ul>
  )
}
